import { render, staticRenderFns } from "./AddTagsModal.vue?vue&type=template&id=500f9e4e&"
import script from "./AddTagsModal.vue?vue&type=script&lang=js&"
export * from "./AddTagsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagsModal.vue?vue&type=style&index=0&id=500f9e4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports